import { Component, OnInit } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manual-entrance-exit-transit-daily',
  templateUrl: './manual-entrance-exit-transit-daily.component.html',
  styleUrls: ['./manual-entrance-exit-transit-daily.component.css'],
  standalone: false,
})
export class ManualEntranceExitTransitDailyComponent implements OnInit {

  readonly manualTopLink: string = AppConst.ROUTING_LINK_MANUAL_INDEX;
  readonly reflectDataLink: string = AppConst.ROUTING_LINK_MANUAL_REFLECT_DATA;
  readonly manualSelectEntranceExitTransitDailyDialogLink: string = AppConst.ROUTING_LINK_MANUAL_SELECT_ENTRANCE_EXIT_TRANSIT_DAILY_DIALOG;
  readonly manualEntranceExitTransitDailyDialogLink: string = AppConst.ROUTING_LINK_MANUAL_ENTRANCE_EXIT_TRANSIT_DAILY_DIALOG;

  currentLang: string = 'ja';

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translate.currentLang;
  }

}
